import axios from "axios";
import router from "vue-router";
import { Message } from "view-design";
import Router from "@/router/index";
// import * as $globalFun from '../assets/js/common'
import qs from "qs";

/**
 * 提示函数
 * 显示三秒后关闭
 */
const tip = msg => {
  Message.info({
    content: msg,
    duration: 10,
  });
};
/* 跳转登录页，携带当前页面路由，以期在登录页面完成登录后返回当前页面，适用于未登录也能进行查看的页面 */
const toLogin = () => {
  router.replace({
    path: "/home/login",
    query: {
      // redirect: router.currentRoute.fullPath
    },
  });
};
/**
 * 请求失败后的错误统一处理
 * @param { Number } status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  console.log("status", status);
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      tip("登录过期，请重新登录");
      sessionStorage.removeItem("token");
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      tip("请求的资源不存在");
      break;
    default:
      console.log(other);
  }
};
// 创建并配置 axios 实例
// 不做 baseUrl 的设置，可能会出现不同 baseUrl 的情况，详情见 api.js
const Axios = axios.create({
  timeout: 60000, // 请求超时时间
  responseType: "json",
  withCredentials: false, // 是否允许携带cookie
  headers: {
    // 'Access-Control-Allow-Origin': '*'
  },
});
// 设置 post 请求头
Axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// 请求拦截器
Axios.interceptors.request.use(
  config => {
    // if (window.sessionStorage.getItem('token')) {
    //   config.headers.Authorization = JSON.parse(window.sessionStorage.getItem('token'));
    // }
    return config;
  },
  error => {
    this.$Message.warning({
      content: error,
      duration: 3,
    });
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  },
  /*
  服务器状态码不是 2 开头的情况
  这里需要和后台统一好错误状态码
  */
  error => {
    // errorHandle(error.response.success);
    return Promise.reject(error);
  }
);

// 返回状态判断

// 公共Get方法
export function Get(url, params) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false });
      },
    })
      .then(
        response => {
          if (response.data !== null) {
            resolve(response.data);
          }
          if (response.data.success === 2 && response.data.msg === "未登录！") {
            // this.$Message.error("登录信息失效，请重新登录！");
            Message.error("登录信息失效，请重新登录！");

            this.closeAllTags();
            Router.push({ path: "/" });
          }
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}

export function DELETE(url, params) {
  return new Promise((resolve, reject) => {
    Axios.delete(url, {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false });
      },
    })
      .then(
        response => {
          if (response.data !== null) {
            resolve(response.data);
          }
          if (response.data.success === 2 && response.data.msg === "未登录！") {
            // this.$Message.error("登录信息失效，请重新登录！");
            Message.error("登录信息失效，请重新登录！");

            this.closeAllTags();
            Router.push({ path: "/" });
          }
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}

// 公共 post 方法
export function POST(url, params) {
  let data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    Axios.post(url, data)
      .then(
        response => {
          if (response.data.success === 2 && response.data.msg === "未登录！") {
            // this.$Message.error("登录信息失效，请重新登录！");
            Message.error("登录信息失效，请重新登录！");
            this.closeAllTags();
            Router.push({ path: "/" });
          }
          resolve(response.data);
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}

//清除tags
function closeAllTags(view) {
  this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
    if (this.affixTags.some(tag => tag.path === view.path)) {
      return;
    }
    this.toLastView(visitedViews, view);
  });
}



// WEBPACK FOOTER //
// ./src/api/http.js